/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Hint_Message_BeforeInputs */

const en_paste_hint_message_before = /** @type {(inputs: Paste_Hint_Message_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy data from Excel and press`)
};

const nl_paste_hint_message_before = /** @type {(inputs: Paste_Hint_Message_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieer data uit Excel en druk op`)
};

/**
* | output |
* | --- |
* | "Copy data from Excel and press" |
*
* @param {Paste_Hint_Message_BeforeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const paste_hint_message_before = /** @type {((inputs?: Paste_Hint_Message_BeforeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Hint_Message_BeforeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_paste_hint_message_before(inputs)
	return en_paste_hint_message_before(inputs)
});